import * as React from "react";
import UniversalTable from "./UniversalTable/UniversalTable";
import { IUniversalTableColumn, IUniversalTableAddAction } from "./UniversalTable/interfaces";
import { convertDateStringToNumber, today } from "../../utilities/dateTimeUtils";
import { DATE_FORMAT } from "../../constants/TIME";
import { useTranslation } from "react-i18next";

export interface ISalesDateRangesTable {
    dateRanges: any;
    handleEditDateRange: any;
    handleAddDateRange: any;
    handleDeleteFinished: any;
    isRequestingDateRanges: boolean;
    oneDateRange?: boolean;
    isFilterableSubscription?: boolean;
}

export const SalesDateRangesTable: React.FunctionComponent<ISalesDateRangesTable> = ({
    dateRanges,
    handleEditDateRange,
    handleAddDateRange,
    handleDeleteFinished,
    isRequestingDateRanges,
    oneDateRange,
    isFilterableSubscription
}: ISalesDateRangesTable) => {
    const { t } = useTranslation();
    const tableRef = React.createRef();
    const defaultStartDate = convertDateStringToNumber(today().format(DATE_FORMAT));

    const dateRangesTableColumns: IUniversalTableColumn[] = [
        {
            type: "date",
            title: t("admin.manageSubscriptionUserDateRangesView.startDate"),
            field: "startDate",
            defaultValue: defaultStartDate,
            validate: rowData => {
                return rowData?.startDate === 0 || rowData?.endDate === 0
                    ? true
                    : rowData?.startDate > rowData?.endDate
                    ? { isValid: false, helperText: t("admin.manageSubscriptionUserDateRangesView.startDateError") }
                    : true;
            }
        },
        {
            type: "visibility_select",
            title: "Visibility start date",
            field: "visibilityStartDate",
            dateField: "startDate",
            defaultValue: defaultStartDate,
            categories: ["start_date", "custom"],
            validate: rowData => {
                return rowData?.visibilityStartDate === 0 || rowData?.visibilityEndDate === 0
                    ? true
                    : rowData?.visibilityStartDate > rowData?.visibilityEndDate
                    ? { isValid: false, helperText: t("admin.manageSubscriptionUserDateRangesView.startDateError") }
                    : true;
            }
        },
        {
            type: "actions",
            title: t("admin.taskView.actions"),
            actions: [
                {
                    name: "edit",
                    tooltip: t("admin.manageSubscriptionUserDateRangesView.editDateRange"),
                    onEditFinished: (index, newValue) => handleEditDateRange(index, newValue)
                },
                {
                    name: "add",
                    disabled: isFilterableSubscription || (oneDateRange === true && dateRanges.length !== 0),
                    tooltip: t("admin.manageSubscriptionUserDateRangesView.addDateRange"),
                    onAddFinished: newRange => handleAddDateRange(newRange),
                    disabledTooltip: isFilterableSubscription
                        ? "Date ranges for filterable subscriptions can be added only via Subscription request."
                        : "Date range cannot be added."
                } as IUniversalTableAddAction,
                {
                    name: "delete",
                    tooltip: t("admin.manageSubscriptionUserDateRangesView.deleteDateRange"),
                    onDeleteFinished: index => handleDeleteFinished(index),
                    deleteQuestion: t("admin.manageSubscriptionUserDateRangesView.deleteQuestion")
                }
            ]
        }
    ];

    return (
        <>
            <UniversalTable
                tableRef={tableRef}
                columns={dateRangesTableColumns}
                data={dateRanges}
                isLoading={isRequestingDateRanges}
                emptyDataMessage={t("admin.manageSubscriptionUserDateRangesView.noDataRanges")}
                pagingDisabled={oneDateRange}
            />
        </>
    );
};
